import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getDefaultNomenclatureCodeIndex,
  Nomenclature,
} from "common/models/Nomenclature";
import moment from "moment";
import ListGroup from "@cc/react-components/ListGroup";

export interface Props extends React.ButtonHTMLAttributes<HTMLElement> {
  /**
   * The five nomenclature codes to be displayed
   */
  nomenclatureCodes: Nomenclature[][];
  setNomenclatureCode(n: Nomenclature[]): void;
}

const NomenclatureCode = ({
  nomenclatureCodes,
  setNomenclatureCode,
}: Props) => {
  const [t] = useTranslation();
  const [defaultCode, setDefaultCode] = useState(0);
  useEffect(() => {
    const index = getDefaultNomenclatureCodeIndex(
      moment().toDate(),
      nomenclatureCodes
    );
    setDefaultCode(index);
    setNomenclatureCode(nomenclatureCodes[index]);
  }, [nomenclatureCodes, setNomenclatureCode]);

  return (
    <ListGroup>
      {nomenclatureCodes.map((nomenclature, index) => (
        <ListGroup.Item
          key={index}
          className="text-center"
          active={index === defaultCode}
          onClick={() => {
            setDefaultCode(index);
            setNomenclatureCode(nomenclatureCodes[index]);
          }}
        >
          <div className="font-weight-bold">
            {nomenclature.map((n) => n.code.toString()).join(" + ")}
          </div>
          {t(nomenclature[nomenclature.length - 1].title)}
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default NomenclatureCode;
